import React from 'react';
import './FeaturedProjects.css';

const FeaturedProjects = ({ data }) => {
  return (
    <section id="projects" className="featured-projects">
      <div className="container">
        <h2 className="section-title">Featured Projects</h2>
        <p className="section-subtitle">
          Highlighting recent AI integration and automation work
        </p>
        <div className="projects-list">
          {data.featuredProjects.map((project, index) => (
            <div key={index} className="project-item">
              <div className="project-content">
                <div className="project-header">
                  <h3 className="project-title">{project.title}</h3>
                  {project.role && (
                    <span className="project-role">{project.role}</span>
                  )}
                </div>
                <p className="project-description">{project.description}</p>
                <div className="project-footer">
                  {project.tech && (
                    <div className="project-tech">
                      <strong>Tech:</strong>
                      <div className="tech-tags">
                        {project.tech.split(',').map((tech, i) => (
                          <span key={i} className="tech-tag">{tech.trim()}</span>
                        ))}
                      </div>
                    </div>
                  )}
                  {project.client && (
                    <div className="project-client">
                      <strong>Client:</strong> {project.client}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
